import { LinkOutlined } from "@ant-design/icons";
import UMCAttributeView from "./UMCAttributeView";
import { getTranslated } from "../../utils/CommonUtils";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

/**
 * LinkWidget component
 * 
 * Displays two linked attributes (publicnetworkcos and its description) 
 * with an icon in between.  
 * 
 * @param {*} props
 * @param {Array} props.attribute Array of attribute objects (length: 2 expected).
 * @param {Object} props.value Current values for the attributes.
 * @param {Boolean} props.isReadOnly Flag to make fields read-only.
 * @param {Function} props.handleSchemaDataChange Callback to update schema data.
 */

function LinkWidget(props) {

    // State to hold left and right attribute fields
  const [leftField, setLeftField] = useState({})
  const [rightField, setRightField] = useState({})

  const dict = useSelector(state => state.common.dict)

  // Extract left and right fields from props.attribute
  useEffect(() => {
    if(props.attribute?.length) {
      setLeftField(props.attribute.length > 0 ? props.attribute[0] : {})
      setRightField(props.attribute.length > 1 ? props.attribute[1] : {})
    }
  }, [props.attribute])

  // attribute view block
  const getAttributeView = attribute => (
    <div className="link-widget-attr">
      <label>{getTranslated(dict, attribute.label)}:</label>
      <UMCAttributeView
        attribute={{ ...attribute, isReadOnly: props.isReadOnly }}
        handleSchemaDataChange={props.handleSchemaDataChange}
      />
    </div>
  )

  // Render the LinkWidget with left field, icon, and right field
  return (
    <div className="link-widget-parent">
      {getAttributeView(leftField)}
      <div className="link-widget-icon">
        <LinkOutlined className="link-widget-svg" />
      </div>
      {getAttributeView(rightField)}
    </div>
  )
}

export default LinkWidget
